export default __webpack_public_path__ + "static/media/dark-bg.1e340dba.png";